module.exports = __webpack_public_path__ + "static/media/guarantee-product-3.18857be0.png";